// Widget Scripts
import swiperWidget from './js/widgets/swiperWidget.js';
import cardWidgetSEOText from './js/widgets/cardWidgetSEOText.js';
import cardWidgetIconButtons from './js/widgets/cardWidgetIconButtons.js';
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';
import swiperWidgetImageCarousel from './js/widgets/swiperWidgetImageCarousel.js';
import cardWidgetCarouselContent from './js/widgets/cardWidgetCarouselContent.js';
import cardWidgetImageAndText from './js/widgets/cardWidgetImageAndText.js';

import swiperWidgetFair from './js/widgets/fair-homepage/swiperWidgetFair.js';
import cardWidgetFairSEOText from './js/widgets/fair-homepage/cardWidgetFairSEOText.js';
import cardWidgetFairIconButtons from './js/widgets/fair-homepage/cardWidgetFairIconButtons.js';
import cardWidgetFairHeadline from './js/widgets/fair-homepage/cardWidgetFairHeadline.js';
import cardWidgetFairGetInvolved from './js/widgets/fair-homepage/cardWidgetFairGetInvolved.js';
import swiperWidgetFairImageCarousel from './js/widgets/fair-homepage/swiperWidgetFairImageCarousel.js';
import cardWidgetFairCarouselContent from './js/widgets/fair-homepage/cardWidgetFairCarouselContent.js';
import cardWidgetFairSponsors from './js/widgets/fair-homepage/cardWidgetFairSponsors.js';

// Custom Theme Scripts
import './js/localjs.js';

const fairHomepagePath = '/p/fair';

// Initialize Homepage Widgets
if ((window.location.pathname === '/') || (window.location.pathname === '/default.aspx')) {
  
  // Events Mode and Cookies
  const origin = window.location.origin;
  const referrer = document.referrer;

  $(document).ready(function() {
    const eventMode = $('body').hasClass('eventsMode');

    if (eventMode) {

      // redirect homepage to fair homepage subpage if coming from external url
      if (!referrer.includes(origin)) {
        window.location.replace(origin + fairHomepagePath);
      } else {
        swiperWidget();   
        cardWidgetSEOText();
        cardWidgetIconButtons();
        multiScheduleFeature();
        swiperWidgetImageCarousel();
        cardWidgetCarouselContent();
        cardWidgetImageAndText();
      }
      
    } else {
      swiperWidget();   
      cardWidgetSEOText();
      cardWidgetIconButtons();
      multiScheduleFeature();
      swiperWidgetImageCarousel();
      cardWidgetCarouselContent();
      cardWidgetImageAndText();

      $('#siteInfoBannerWidget').appendTo('.countdown-wrapper-inner');
    }
  });
}

$(document).ready(function() {
  let fairSubpage = $('body').hasClass('subpage-fair');
  const fairHomepage = $('body').hasClass('subpage-fair-home');
  const path = window.location.pathname;

  // check sessionStorage to see if the fairtheme has been set to fair from a previous page
  let fairTheme = sessionStorage.getItem('fairtheme');

  function storeThemeStatus() {
    if (fairSubpage || fairHomepage) {
      sessionStorage.setItem('fairtheme', 'true');
    } else {
      sessionStorage.setItem('fairtheme', 'false');
    }
  }

  // on events listing page, if previously visited page was a fair subpage, give the events listing page the fair subpage theme
  if (path === '/events') {
    if (fairTheme === 'true') {
      $('body').addClass('subpage-fair');
      fairSubpage = true;
    }
  } else {
    $(window).load(function() {
      if ((fairTheme === 'true') && (path.includes('/events')) && ($('.eventListingPage').length > 0)) {
        $('body').addClass('subpage-fair');
        fairSubpage = true;
        storeThemeStatus();
        cardWidgetFairSponsors();
        $('.header-logo').attr('href', fairHomepagePath);
      }
    });
  }

  storeThemeStatus();

  if (fairHomepage) {
    // Fair Homepage
      const fairHomeHTML = `
        <div class="section-tier-one">
          <div class="countdown-wrapper">
            <div class="countdown-wrapper-inner">

            </div>
          </div>
          <div id="swiperWidgetFair"></div>
        </div>
        <div class="section-tier-two">
          <div id="cardWidgetFairSEOText"></div>
        </div>
        <div class="section-tier-three">
          <div id="cardWidgetFairIconButtons"></div>
        </div>
        <div class="section-tier-four">
          <div id="multiScheduleFeature" class="widget multiFeature"></div>
          <div id="cardWidgetFairHeadline"></div>
          <div class="section-tier-four-inner">
            <div id="cardWidgetFairGetInvolved"></div>
          </div>
        </div>
        <div class="section-tier-five">
          <div id="swiperWidgetFairImageCarousel"></div>    
          <div id="cardWidgetFairCarouselContent"></div>  
        </div>                            
      `;

      $('body').addClass('subpage-fair');
      $('main.content').html(fairHomeHTML);

      $('#siteInfoBannerWidget').appendTo('.countdown-wrapper-inner');

      swiperWidgetFair(); 
      cardWidgetFairSEOText();
      cardWidgetFairIconButtons();
      cardWidgetFairHeadline();
      cardWidgetFairGetInvolved();
      swiperWidgetFairImageCarousel();
      cardWidgetFairCarouselContent();
      cardWidgetFairSponsors();

      $('.header-logo').attr('href', fairHomepagePath);
  }

  if (fairSubpage) {
    cardWidgetFairSponsors();
    $('.header-logo').attr('href', fairHomepagePath);
  }

});










